import { render } from "./HODClaimsComponent.vue?vue&type=template&id=3a117fa6&scoped=true"
import script from "./HODClaimsComponent.vue?vue&type=script&lang=js"
export * from "./HODClaimsComponent.vue?vue&type=script&lang=js"

import "./HODClaimsComponent.vue?vue&type=style&index=0&id=3a117fa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a117fa6"]])

export default __exports__